import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useLanguage } from './context/LanguageContext';
import LanguageSelector from './components/LanguageSelector';
import './App.css';

function App() {
  const { t, currentLanguage } = useLanguage();
  const [showCopied, setShowCopied] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentCertIndex, setCurrentCertIndex] = useState(0);
  const [currentToolIndex, setCurrentToolIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showInsigniasPage, setShowInsigniasPage] = useState(false);
  const [selectedInsignia, setSelectedInsignia] = useState(null);
  
  // Estado del formulario de contacto
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Estados para el modal de certificaciones
  const [showCertModal, setShowCertModal] = useState(false);
  const [selectedCertImage, setSelectedCertImage] = useState('');
  const [selectedCertTitle, setSelectedCertTitle] = useState('');
  
  const carouselRef = useRef(null);
  const toolsCarouselRef = useRef(null);
  const contactFormRef = useRef(null);
  const email = 'davidcigaran@gmail.com';

  // Función para descargar el CV
  const handleDownloadCV = () => {
    const pdfUrl = '/curriculum.pdf';
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'David_Cigaran_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Función para hacer scroll a la sección "Sobre mí"
  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Detectar si es dispositivo móvil
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // USANDO useMemo para variables que dependen de t()
  const sliderCertifications = useMemo(() => [
    { 
      id: 1, 
      title: t('certifications.theBridge'), 
      image: '/img/bridge.png', 
      expedition: '2026', 
      description: t('certifications.description.theBridge'),
      issuedTo: t('certifications.issuedTo'),
      issuedDate: '4 de mayo de 2026',
      issuedBy: t('certifications.issuedBy'),
      course: t('certifications.course')
    },
    { 
      id: 2, 
      title: t('certifications.burpSuite'), 
      image: '/img/portswigger.png', 
      expedition: t('certifications.inProgress'), 
      description: t('certifications.description.burpSuite'),
      issuedTo: t('certifications.issuedTo'),
      issuedDate: t('certifications.inProgress'),
      issuedBy: 'PortSwigger',
      course: t('certifications.selfTaught')
    },
    { 
      id: 3, 
      title: t('certifications.ejpt'), 
      image: '/img/ejpt.png', 
      expedition: t('certifications.inProgress'), 
      description: t('certifications.description.ejpt'),
      issuedTo: t('certifications.issuedTo'),
      issuedDate: t('certifications.inProgress'),
      issuedBy: 'eLearnSecurity',
      course: t('certifications.selfTaught')
    }
  ], [t]);

  // Datos estáticos de insignias
  const certificationsData = [
    { 
      id: 1, 
      title: '🏅Cibersecurity Profile Recon', 
      image: '/img/cibersecurity_recon.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '20 de noviembre de 2025, 14:58',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 2, 
      title: '🏅Assets Protection', 
      image: '/img/assets_protection.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '24 de febrero de 2026, 14:07',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 3, 
      title: '🏅Cybersecurity Fundamentals', 
      image: '/img/cybersecurity_fundamentals.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:01',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 4, 
      title: '🏅Web Applications Attacks', 
      image: '/img/web_applications_attacks.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:07',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 5, 
      title: '🏅Incident Response', 
      image: '/img/-Incident_Response-.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:56',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 6, 
      title: '🏅Lateral Movements', 
      image: '/img/Lateral_Movements.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:38',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 7, 
      title: '🏅Assets Exploitation', 
      image: '/img/Assets_Exploitation.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:28',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    },
    { 
      id: 8, 
      title: '🏅Privilege Escalation', 
      image: '/img/-Privilege_Escalation-.png', 
      expedition: '2026', 
      issuedTo: 'David Cigaran Flores',
      issuedDate: '4 de mayo de 2026, 12:25',
      issuedBy: 'The Bridge | Digital Talent Accelerator',
      course: 'Bootcamp Ciberseguridad (Core-Septiembre 25)'
    }
  ];

  // Education history con useMemo - INVERTIDO (el más reciente primero)
  const educationHistory = useMemo(() => [
    { 
      id: 5, 
      title: t('education.4.title'), 
      date: '2025-2026', 
      institution: 'The Bridge' 
    },
    { 
      id: 4, 
      title: t('education.3.title'), 
      date: '2023-2025', 
      institution: 'Centro de Estudios ALMI (Deusto)' 
    },
    { 
      id: 3, 
      title: t('education.2.title'), 
      date: '2021-2022', 
      institution: 'Campus Training Bilbao' 
    },
    { 
      id: 2, 
      title: t('education.1.title'), 
      date: '2019-2021', 
      institution: 'UPV/EHU Leioa' 
    },
    { 
      id: 1, 
      title: t('education.0.title'), 
      date: '2019', 
      institution: 'Ntra.Sra del Rosario Dominicas Barakaldo' 
    }
  ], [t]);

  // Experiences con useMemo
  const experiences = useMemo(() => [
    {
      id: 1,
      type: 'professional',
      title: t('experience.professional.title'),
      subtitle: t('experience.professional.subtitle'),
      period: t('experience.professional.period'),
      icon: '💼',
      intro: t('experience.professional.intro'),
      tasks: [
        t('experience.professional.tasks.0'),
        t('experience.professional.tasks.1'),
        t('experience.professional.tasks.2'),
        t('experience.professional.tasks.3'),
        t('experience.professional.tasks.4'),
        t('experience.professional.tasks.5'),
        t('experience.professional.tasks.6')
      ],
      technologies: ['WordPress', 'MySQL', 'PHP', 'HTML', 'CSS', 'JavaScript']
    },
    {
      id: 2,
      type: 'academic',
      title: t('experience.academic.title'),
      subtitle: t('experience.academic.subtitle'),
      period: t('experience.academic.period'),
      icon: '🎓',
      intro: t('experience.academic.intro'),
      tasks: [
        t('experience.academic.tasks.0'),
        t('experience.academic.tasks.1'),
        t('experience.academic.tasks.2'),
        t('experience.academic.tasks.3')
      ],
      technologies: ['Kali Linux', 'Nmap', 'Metasploit', 'Burp Suite', 'Nessus', 'Wireshark', 'John the Ripper', 'Hydra', 'Gobuster', 'DVWA', 'Metasploitable', 'Windows Server', 'Ubuntu Server', 'Pfsense', 'Wazuh', 'Snort', 'Autopsy']
    }
  ], [t]);

  // Tools categories con useMemo
  const toolsCategories = useMemo(() => [
    {
      title: t('tools.categories.0.title'),
      items: [
        t('tools.categories.0.items.0'),
        t('tools.categories.0.items.1'),
        t('tools.categories.0.items.2'),
        t('tools.categories.0.items.3'),
        t('tools.categories.0.items.4'),
        t('tools.categories.0.items.5'),
        t('tools.categories.0.items.6'),
        t('tools.categories.0.items.7')
      ]
    },
    {
      title: t('tools.categories.1.title'),
      items: [
        t('tools.categories.1.items.0'),
        t('tools.categories.1.items.1'),
        t('tools.categories.1.items.2'),
        t('tools.categories.1.items.3'),
        t('tools.categories.1.items.4'),
        t('tools.categories.1.items.5'),
        t('tools.categories.1.items.6'),
        t('tools.categories.1.items.7')
      ]
    },
    {
      title: t('tools.categories.2.title'),
      items: [
        t('tools.categories.2.items.0'),
        t('tools.categories.2.items.1'),
        t('tools.categories.2.items.2'),
        t('tools.categories.2.items.3'),
        t('tools.categories.2.items.4'),
        t('tools.categories.2.items.5'),
        t('tools.categories.2.items.6')
      ]
    },
    {
      title: t('tools.categories.3.title'),
      items: [
        t('tools.categories.3.items.0'),
        t('tools.categories.3.items.1'),
        t('tools.categories.3.items.2'),
        t('tools.categories.3.items.3'),
        t('tools.categories.3.items.4'),
        t('tools.categories.3.items.5'),
        t('tools.categories.3.items.6')
      ]
    },
    {
      title: t('tools.categories.4.title'),
      items: [
        t('tools.categories.4.items.0'),
        t('tools.categories.4.items.1'),
        t('tools.categories.4.items.2'),
        t('tools.categories.4.items.3'),
        t('tools.categories.4.items.4')
      ]
    },
    {
      title: t('tools.categories.5.title'),
      items: [
        t('tools.categories.5.items.0'),
        t('tools.categories.5.items.1'),
        t('tools.categories.5.items.2'),
        t('tools.categories.5.items.3'),
        t('tools.categories.5.items.4'),
        t('tools.categories.5.items.5'),
        t('tools.categories.5.items.6')
      ]
    }
  ], [t]);

  const renderHTML = (text) => {
    return { __html: text };
  };

  const currentYear = new Date().getFullYear();

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 2000);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const openCertModal = (image, title) => {
    setSelectedCertImage(image);
    setSelectedCertTitle(title);
    setShowCertModal(true);
  };

  const closeCertModal = () => {
    setShowCertModal(false);
    setSelectedCertImage('');
    setSelectedCertTitle('');
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ type: '', message: '' });

    const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xvzdjkdd';

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          _replyto: formData.email
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        setFormStatus({ 
          type: 'success', 
          message: t('formMessages.success')
        });
        setFormData({ name: '', subject: '', email: '', message: '' });
      } else {
        setFormStatus({ 
          type: 'error', 
          message: t('formMessages.error')
        });
      }
    } catch (error) {
      console.error('Error:', error);
      setFormStatus({ 
        type: 'error', 
        message: t('formMessages.connectionError')
      });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setFormStatus({ type: '', message: '' });
      }, 5000);
    }
  };

  const scrollToContactForm = (e) => {
    if (e) e.preventDefault();
    contactFormRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInsigniasClick = (e) => {
    e.preventDefault();
    setShowInsigniasPage(true);
    setSelectedInsignia(null);
    window.scrollTo(0, 0);
  };

  const handleVolverClick = () => {
    if (selectedInsignia) {
      setSelectedInsignia(null);
    } else {
      setShowInsigniasPage(false);
    }
    window.scrollTo(0, 0);
  };

  const handleInsigniaClick = (insignia) => {
    // Añadir descripción y criterios traducidos al hacer click
    const insigniaConTraduccion = {
      ...insignia,
      description: t(`insignias.items.${insignia.id - 1}.description`),
      criteria: t(`insignias.items.${insignia.id - 1}.criteria`, { returnObjects: true }) || []
    };
    setSelectedInsignia(insigniaConTraduccion);
    window.scrollTo(0, 0);
  };

  const nextCertSlide = () => {
    setCurrentCertIndex((prevIndex) => 
      prevIndex === sliderCertifications.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevCertSlide = () => {
    setCurrentCertIndex((prevIndex) => 
      prevIndex === 0 ? sliderCertifications.length - 1 : prevIndex - 1
    );
  };

  const nextToolSlide = () => {
    setCurrentToolIndex((prevIndex) => 
      prevIndex === 5 ? 0 : prevIndex + 1
    );
  };

  const prevToolSlide = () => {
    setCurrentToolIndex((prevIndex) => 
      prevIndex === 0 ? 5 : prevIndex - 1
    );
  };

  const handleCarouselClick = (e) => {
    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const containerWidth = rect.width;
    
    if (clickX < containerWidth / 2) {
      prevToolSlide();
    } else {
      nextToolSlide();
    }
  };

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const certInterval = setInterval(() => {
      nextCertSlide();
    }, 5000);

    return () => {
      clearInterval(certInterval);
    };
  }, []);

  // Página de detalle de insignia individual
  if (selectedInsignia) {
    return (
      <div className="App">
        <header className="header insignia-detail-header">
          <nav className="nav insignia-nav">
            <button onClick={handleVolverClick} className="volver-btn">
              {t('insignias.backButton')}
            </button>
          </nav>
        </header>

        <section className="insignia-detail-page">
          <div className="container">
            <div className="insignia-detail-card">
              <div className="insignia-detail-image-container">
                <img 
                  src={selectedInsignia.image} 
                  alt={selectedInsignia.title} 
                  className="insignia-detail-image"
                />
              </div>
              <div className="insignia-detail-info">
                <h1 className="insignia-detail-title">{selectedInsignia.title}</h1>
                <p className="insignia-detail-issued">{t('insignias.detail.awardedTo')}: {selectedInsignia.issuedTo}</p>
                <p className="insignia-detail-date">{t('insignias.detail.issued')}: {selectedInsignia.issuedDate}</p>
                <p className="insignia-detail-issuer">{t('insignias.detail.issuedBy')}: {selectedInsignia.issuedBy}</p>
                <p className="insignia-detail-course">{t('insignias.detail.course')}: {selectedInsignia.course}</p>
                <div className="insignia-detail-description-container">
                  <h3>{t('insignias.detail.description')}</h3>
                  <p className="insignia-detail-description">{selectedInsignia.description}</p>
                </div>
                <div className="insignia-detail-criteria">
                  <h3>{t('insignias.detail.criteria')}</h3>
                  <ul>
                    {selectedInsignia.criteria.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="footer">
          {t('footer.copyright').replace('[YEAR]', currentYear)}
        </footer>
      </div>
    );
  }

  // Página de listado de insignias
  if (showInsigniasPage) {
    return (
      <div className="App">
        <header className="header insignias-list-header">
          <nav className="nav insignias-nav">
            <button onClick={handleVolverClick} className="volver-btn">
              {t('insignias.backButton')}
            </button>
          </nav>
        </header>

        <section className="insignias-list-page">
          <div className="container">
            <h1 className="insignias-list-title">{t('insignias.pageTitle')}</h1>
            <div className="insignias-list-subtitle-container">
              <p className="insignias-list-subtitle">{t('insignias.exploreMessage')}</p>
            </div>
            <div className="insignias-list">
              {certificationsData.map((cert) => (
                <div 
                  key={cert.id} 
                  className="insignia-list-item"
                  onClick={() => handleInsigniaClick(cert)}
                >
                  <span className="insignia-list-name">{cert.title}</span>
                  <span className="insignia-list-arrow">→</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <footer className="footer">
          {t('footer.copyright').replace('[YEAR]', currentYear)}
        </footer>
      </div>
    );
  }

  // Página principal
  return (
    <div className="App">
      <header className="header">
        <div className="language-selector-top-left">
          <LanguageSelector />
        </div>

        <nav className="nav">
          <a href="/" className="logo">{t('nav.logo')}</a>

          {!isMobile && (
            <>
              <div className="nav-links">
                <a href="#about">{t('nav.about')}</a>
                <a href="#certifications">{t('nav.certifications')}</a>
                <a href="#experience">{t('nav.experience')}</a>
                <a href="#a_history">{t('nav.education')}</a>
                <a href="#habilidades">{t('nav.tools')}</a>
                <a href="#contact" onClick={scrollToContactForm} className="contact-nav-link">
                  {t('nav.contact')}
                </a>
              </div>

              <div className="nav-right">
                <div className="header-buttons">
                  <a 
                    href="#insignias"
                    onClick={handleInsigniasClick}
                    className="project-link"
                  >
                    {t('nav.badges')}
                  </a>
                  <div className="social">
                    <a 
                      href="https://www.linkedin.com/in/david-cigaran-53b765205/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {t('hero.linkedin')}
                    </a>
                    {/* Enlace a GitHub eliminado */}
                  </div>
                </div>
                <div className="language-selector">
                  <LanguageSelector />
                </div>
              </div>
            </>
          )}
        </nav>
      </header>

      <section className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>{t('hero.greeting')}</h1>
            <p className="tagline">{t('hero.tagline')}</p>
            <p className="description">{t('hero.description')}</p>
            
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">+10</span>
                <span className="stat-label">{t('hero.stats.projects')}</span>
              </div>
              <div className="stat">
                <span className="stat-number">+3</span>
                <span className="stat-label">{t('hero.stats.years')}</span>
              </div>
              <div className="stat">
                <span className="stat-number">∞</span>
                <span className="stat-label">{t('hero.stats.curiosity')}</span>
              </div>
            </div>
            
            <div className="hero-buttons">
              {/* Botón que antes era "Proyectos" ahora descarga el CV */}
              <button onClick={handleDownloadCV} className="btn btn-primary">
                {t('hero.buttons.downloadCV')}
              </button>
              {/* Botón que antes descargaba CV ahora es "Sobre mí" y hace scroll a about */}
              <button onClick={scrollToAbout} className="btn btn-download">
                Sobre mí
              </button>
            </div>
          </div>
          
          <div 
            className="hero-image" 
            onClick={() => setShowImageModal(true)}
            title={t('modal.expandImage')}
          >
            <div className="image-wrapper">
              <img 
                src="/img/davvv.jpg" 
                alt="Profile" 
                className="profile-img" 
              />
              <div className="image-glow"></div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="about-section">
        <div className="about-container">
          <div className="about-header">
            <h2>{t('about.title')}</h2>
            <p className="about-subtitle">{t('about.subtitle')}</p>
          </div>
          
          <div className="about-content">
            <div className="about-text">
              <p className="about-description">
                {t('about.description1')}
                {!isExpanded && (
                  <>
                    {' '}
                    <button className="read-more-btn" onClick={toggleReadMore}>
                      {t('about.readMore')}
                    </button>
                  </>
                )}
              </p>
              
              {isExpanded && (
                <>
                  <p className="about-description">{t('about.description2')}</p>
                  <p className="about-description">{t('about.description3')}</p>
                  <button className="read-less-btn" onClick={toggleReadMore}>
                    {t('about.readLess')}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      <section id="certifications" className="section certifications-section">
        <div className="container">
          <h2 className="section-title">{t('sections.certifications')}</h2>
          
          <div className="certifications-carousel" ref={carouselRef}>
            <div className="carousel-wrapper">
              <div className="carousel-track" style={{ transform: `translateX(-${currentCertIndex * 100}%)` }}>
                {[...sliderCertifications, ...sliderCertifications, ...sliderCertifications].map((cert, index) => (
                  <div key={`${cert.id}-${index}`} className="carousel-slide">
                    <div className="cert-card">
                      <img 
                        src={cert.image} 
                        alt={cert.title} 
                        className="cert-image"
                        onClick={() => openCertModal(cert.image, cert.title)}
                        style={{ cursor: 'pointer' }}
                      />
                      <div className="cert-content">
                        <h3 className="cert-title">{cert.title}</h3>
                        {cert.expedition === t('certifications.inProgress') ? (
                          <p className="cert-expedition in-progress">🟡 {cert.expedition}</p>
                        ) : (
                          <p className="cert-expedition completed">{t('certifications.expedition')}: {cert.expedition}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <button className="carousel-btn prev-btn" onClick={prevCertSlide}>‹</button>
            <button className="carousel-btn next-btn" onClick={nextCertSlide}>›</button>
            
            <div className="carousel-indicators">
              {sliderCertifications.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentCertIndex % sliderCertifications.length ? 'active' : ''}`}
                  onClick={() => setCurrentCertIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <br /><br /><br />
      
      <section id="experience" className="section experience-section">
        <div className="container">
          <h2 className="section-title">{t('sections.experience')}</h2>
          
          <div className="experience-cards-container">
            {experiences.map((exp) => (
              <div key={exp.id} className="experience-card-compact">
                <div className="experience-header">
                  <div className="experience-icon">{exp.icon}</div>
                  <div>
                    <h3 className="experience-card-title">{exp.title}</h3>
                    <p className="experience-subtitle">{exp.subtitle}</p>
                    <span className="experience-period">{exp.period}</span>
                  </div>
                </div>

                <div className="experience-body">
                  <p className="experience-intro">{exp.intro}</p>

                  <h4 className="experience-section-subtitle">{t('experience.responsibilities')}</h4>
                  <ul className="experience-tasks-compact">
                    {exp.tasks.map((task, i) => (
                      <li key={i}>• {task}</li>
                    ))}
                  </ul>

                  <h4 className="experience-section-subtitle">{t('experience.technologies')}</h4>
                  <div className="tech-tags">
                    {exp.technologies.map((tech, i) => (
                      <span key={i}>{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <br /><br />

      <section id="a_history" className="section education-section">
        <div className="container">
          <h2 className="section-title education-title">{t('sections.education')}</h2>
          
          <div className="timeline">
            {educationHistory.map((item) => (
              <div key={item.id} className="timeline-item">
                <div className="timeline-content">
                  <h3 className="timeline-title">{item.title}</h3>
                  <div className="timeline-date">{item.date}</div>
                  <p className="timeline-institution">{item.institution}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="habilidades" className="section">
        <div className="container">
          <h2 className="section-title">{t('sections.tools')}</h2>     
          
          <div className="carrusel-instruccion">{t('tools.instruction')}</div>
          
          <div 
            id="habilidades-carousel-container"
            onClick={handleCarouselClick}
            ref={toolsCarouselRef}
          >
            <div 
              id="habilidades-carousel" 
              style={{ 
                transform: `translateX(-${currentToolIndex * 100}%)`,
                transition: 'transform 0.5s ease'
              }}
            >
              {toolsCategories.map((category, categoryIndex) => (
                <div 
                  key={categoryIndex} 
                  className="habilidades-carousel-item" 
                  style={{ opacity: currentToolIndex === categoryIndex ? '1' : '0' }}
                >
                  <h3>{category.title}</h3>
                  <div className="skill-items">
                    {category.items.map((item, itemIndex) => {
                      const imageMap = [
                        ['/img/kali.png', '/img/parrot.png', '/img/ubu.png', '/img/w7.jpeg', '/img/w10.png', '/img/w_server.png', '/img/zorin.png', '/img/tails.png'],
                        ['/img/Dorks.webp', '/img/cen.png', '/img/shodan.jpeg', '/img/spiderfoot.png', '/img/FOCA.png', '/img/maltego.png', '/img/httrack.png', '/img/exiftool.png'],
                        ['/img/nikto.jpeg', '/img/dirb.png', '/img/dirbuster.png', '/img/dirsearch.png', '/img/gobuster.png', '/img/Burp_suite.png', '/img/sqlmap.png'],
                        ['/img/nmap.jpeg', '/img/arp.png', '/img/ping.jpeg', '/img/curl.png', '/img/netcat.png', '/img/wireshark.jpeg', '/img/OpenSSL.jpg'],
                        ['/img/nessus.png', '/img/greenbone.png', '/img/dvwa.jpeg', '/img/aws.png', '/img/vbox.png'],
                        ['/img/hidra.png', '/img/john.png', '/img/hash.jpeg', '/img/decode.png', '/img/meta.png', '/img/bash.png', '/img/mysql.png']
                      ];
                      
                      const imageSrc = imageMap[categoryIndex]?.[itemIndex] || '/img/default.png';
                      const altText = item.split(' ')[0];
                      
                      return (
                        <div key={itemIndex} className="item">
                          <img src={imageSrc} alt={altText}/>
                          <span>{item}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="carousel-indicators">
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <button
                key={index}
                className={`carousel-indicator ${index === currentToolIndex ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentToolIndex(index);
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* SECCIÓN DE CONTACTO */}
      <section id="contact" className="section contact-section" ref={contactFormRef}>
        <div className="container">
          <h2 className="section-title">{t('sections.contact')}</h2>
          
          <div className="contact-form-container">
            {formStatus.message && (
              <div className={`form-status ${formStatus.type}`}>
                {formStatus.message}
              </div>
            )}
            
            <form onSubmit={handleSubmitForm} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">{t('contact.form.nameLabel')}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder={t('contact.form.namePlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">{t('contact.form.subjectLabel')}</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  placeholder={t('contact.form.subjectPlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">{t('contact.form.emailLabel')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder={t('contact.form.emailPlaceholder')}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">{t('contact.form.messageLabel')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows="5"
                  placeholder={t('contact.form.messagePlaceholder')}
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? t('contact.form.submittingButton') : t('contact.form.submitButton')}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Modal para ampliar imagen de certificación */}
      {showCertModal && (
        <div className="cert-modal-overlay" onClick={closeCertModal}>
          <div className="cert-modal-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedCertImage} 
              alt={selectedCertTitle} 
              className="cert-modal-image"
            />
            <h3 className="cert-modal-title">{selectedCertTitle}</h3>
            <button className="cert-modal-close" onClick={closeCertModal}>✕</button>
          </div>
        </div>
      )}

      {showImageModal && (
        <div className="modal-overlay" onClick={() => setShowImageModal(false)}>
          <img 
            src="/img/davvv.jpg" 
            alt="Profile ampliada" 
            className="modal-image"
            onClick={(e) => e.stopPropagation()}
          />
          <button 
            className="modal-close-btn"
            onClick={() => setShowImageModal(false)}
            aria-label={t('modal.close')}
          >
            ✕
          </button>
        </div>
      )}

      <footer className="footer">
        {t('footer.copyright').replace('[YEAR]', currentYear)}
      </footer>
      <div className="background-effect"></div>
    </div>
  );
}

export default App;
